module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-4-e9a81e3dcb92b6740feb03e585ec30eb.jpg";